import { RegisterReviewerRequest, RegisterReviewerResponse } from '../registerreviewer';
import * as _m0 from "protobufjs/minimal";
import { withAuthRetry } from '../utils/authRetry';
import { getServiceUrl } from '../utils/api';

export async function registerReviewer(
    request: RegisterReviewerRequest,
    accessToken: string,
    setAccessToken: (token: string | null) => void,
    logout: () => void
): Promise<RegisterReviewerResponse> {
    const originalApiCall = async (token: string): Promise<Response> => {
        const encodedRequest = RegisterReviewerRequest.encode(request).finish();
        const base64 = _m0.util.base64.encode(encodedRequest, 0, encodedRequest.length);

        const url = getServiceUrl('adminservice', 'registerreviewer');

        const response = await fetch(
            url, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            body: base64
        }
        );
        return response;
    };

    const decodeResponse = (bytes: Uint8Array): RegisterReviewerResponse => {
        return RegisterReviewerResponse.decode(bytes);
    };

    return withAuthRetry(originalApiCall, accessToken, decodeResponse, setAccessToken, logout);
}
